import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyHasCostDocumentFileToAllBookingItemsCommand extends BaseCommand {
  CommandName = "CopyHasCostDocumentFileToAllBookingItems";
  Command: {
    Value: boolean;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: boolean) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Value: value };
  }
}
